<template>
    <div>

        <section id="main-area">
            <div class="container" style="padding-top: 45px">
                <div class="jumbotrn">
                    <div class="row">
                        <div class="col-12 text-right">
                            <button class="btn btn-biletbul-bg-blue btn-sm text-white" v-print="'#print-area'">
                                <mdb-icon icon="print"/>
                                <span class="d-none d-md-inline-block pl-2"> Yazdır</span></button>
                        </div>
                        <div id="print-area">
                            <div v-if="reservationAllCharter">
                                <div v-for="(passenger,index) in reservationAllCharter.person" :key="index"
                                     class="mt-3 ">
                                    <div class="row">
                                        <div class="col"></div>
                                        <div class="col-10">
                                            <div class="row">
                                                <div class="col-12" style="border-radius: 6px;
        border: 1px solid #bbb;
        background-color: #ebeef1;
        box-shadow: none;
        padding: 0.5rem 1rem;">
                                                    <p style="font-size: 16px;margin-bottom: 0">Sayın,</p>
                                                    <p style="font-size: 22px;margin-bottom: 0"><strong>{{passenger.first_name}}
                                                        {{passenger.last_name}}</strong></p>
                                                </div>
                                                <div class="col-12"
                                                     style="background-color: #61af61; padding: 15px; border-radius: 6px; color:white">
                                                    <p style="font-size: 18px;margin-bottom: 0">Biletinizi başarılı bir
                                                        şekilde satın aldınız. </p>
                                                    <p style="font-size: 18px;margin-bottom: 0">Uçuş detaylarınız ve
                                                        elektronik biletiniz aşağıdadır </p>
                                                    <p style="font-size: 18px;margin-bottom: 0">Biletinizin detaylarını
                                                        24 saat öncesinden teyit etmelisiniz.</p>
                                                </div>
                                            </div>
                                            <div class="row" style="margin-top: 25px;">
                                                <div class="col-12" style="background-color: #ececec; padding: 15px;">
                                                    <p style="font-size: 16px;margin-bottom: 0">Rezervasyon No:</p>
                                                    <p style="font-size: 22px;margin-bottom: 0"><strong>{{reservationAllCharter.booking_code}}</strong>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col"></div>
                                    </div>
                                    <div class="row" style="margin-top: 7px">
                                        <div class="col"></div>
                                        <div class="col-10 p-0">
                                            <table class="table w-100">
                                                <th>GİDİŞ UÇUŞU</th>
                                                <th>KALKIŞ</th>
                                                <th>VARIŞ</th>
                                                <th>SÜRE</th>
                                                <th>BAGAJ</th>
                                                <tr>
                                                    <td>
                                                        <p>
                                                            <b>{{reservationAllCharter.departure_charter.airline_name}}</b>
                                                        </p>
                                                        <p>Class</p>
                                                        <p><b>{{reservationAllCharter.departure_charter.class}}</b></p>
                                                    </td>
                                                    <td>
                                                        <p>
                                                            <b>{{reservationAllCharter.departure_charter.departure_hour}}</b>
                                                        </p>
                                                        <p>
                                                            {{reservationAllCharter.departure_charter.departure_date}}</p>
                                                        <p><b>{{reservationAllCharter.departure_charter.from_city_code}}
                                                            ({{reservationAllCharter.departure_charter.from_code}})</b>
                                                        </p>
                                                    </td>
                                                    <td>
                                                        <p>
                                                            <b>{{reservationAllCharter.departure_charter.arrival_hour}}</b>
                                                        </p>
                                                        <p>{{reservationAllCharter.departure_charter.arrival_date}}</p>
                                                        <p><b>{{reservationAllCharter.departure_charter.to_city_code}}
                                                            ({{reservationAllCharter.departure_charter.to_code}})</b>
                                                        </p>
                                                    </td>
                                                    <td>
                                                        <p>{{reservationAllCharter.departure_charter.duration}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{reservationAllCharter.departure_charter.baggage}}</p>
                                                    </td>
                                                </tr>
                                            </table>
                                            <table class="table w-100" v-if="reservationAllCharter.arrival_charter.id">
                                                <th>DÖNÜŞ UÇUŞU</th>
                                                <th>KALKIŞ</th>
                                                <th>VARIŞ</th>
                                                <th>SÜRE</th>
                                                <th>BAGAJ</th>
                                                <tr>
                                                    <td>
                                                        <p><b>{{reservationAllCharter.arrival_charter.airline_name}}</b>
                                                        </p>
                                                        <p>Class</p>
                                                        <p><b>{{reservationAllCharter.arrival_charter.class}}</b></p>
                                                    </td>
                                                    <td>
                                                        <p>
                                                            <b>{{reservationAllCharter.arrival_charter.departure_hour}}</b>
                                                        </p>
                                                        <p>{{reservationAllCharter.arrival_charter.departure_date}}</p>
                                                        <p><b>{{reservationAllCharter.arrival_charter.from_city_code}}
                                                            ({{reservationAllCharter.arrival_charter.from_code}})</b>
                                                        </p>
                                                    </td>
                                                    <td>
                                                        <p><b>{{reservationAllCharter.arrival_charter.arrival_hour}}</b>
                                                        </p>
                                                        <p>{{reservationAllCharter.arrival_charter.arrival_date}}</p>
                                                        <p><b>{{reservationAllCharter.arrival_charter.to_city_code}}
                                                            ({{reservationAllCharter.arrival_charter.to_code}})</b></p>
                                                    </td>
                                                    <td>
                                                        <p>{{reservationAllCharter.arrival_charter.duration}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{reservationAllCharter.arrival_charter.baggage}}</p>
                                                    </td>
                                                </tr>
                                            </table>
                                            <div class="col-12" style="background-color:#ececec; padding: 15px ">
                                                <p style="font-size: 24px; margin-bottom: 0">TOPLAM TUTAR</p>
                                                <p style="margin-bottom: 0;font-size: 28px"><strong>{{reservationAllCharter.amount_paid}}TL</strong>
                                                </p>
                                            </div>
                                            <div style="margin-top: 15px">
                                                <div style="font-size: 24px;background-color:#ececec;padding: 15px ">
                                                    Genel Kurallar
                                                </div>
                                                <p>OLCULARIMIZIN HAVALİMANINA İÇ HAT UÇUŞLARINDA EN GEÇ 3 SAAT, DIŞ HAT
                                                    UÇUŞLARINDA EN GEÇ
                                                    4 SAAT ÖNCE GELMELERİ GEREKMEKTEDİR.
                                                    * YOLCUNUZUN GIDECEGI ULKE'YE AIT GECERLI BIR VIZESI AKTARMALI
                                                    UCUSLARDA TRANSIT VIZESI OLMAMASI SEBEBIYLE
                                                    SEYAHATIN GERCEKLESMEMESI HALINDE BILETBANK (AKDENİZ PE-TUR A.S)
                                                    SORUMLU DEGILDIR.</p>
                                            </div>
                                            <div>
                                                <div style="font-size: 24px;background-color:#ececec;padding: 15px ">
                                                    Önemli Bilgilendirme
                                                </div>
                                                <p>HAVAYOLLARININ KURALLARINA GORE OZELLIKLE UZUN MENZILLI UCUSLARDA
                                                    CHECK-IN ISLEMLERI ERKEN BITEBILMEKTE OLUP,

                                                    PARCA BAGAJ HAKLARI HAVAYOLUNA GORE DEGISIKLIK ARZ
                                                    EDEBILMEKTEDIR.</p>
                                            </div>
                                        </div>
                                        <div class="col"></div>
                                    </div>
                                    <hr>
                                </div>
                            </div>
                            <div v-if="reservationAll">
                                <div v-for="(passenger,index) in passengersAll" :key="index" class="mt-3">
                                    <div class="row">
                                        <div class="col"></div>
                                        <div class="col-10">
                                            <div class="row">
                                                <div class="col-12" style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #ebeef1;
        box-shadow: none;
        padding: 0.5rem 1rem;">
                                                    <p style="font-size: 16px;margin-bottom: 0">Sayın,</p>
                                                    <p style="font-size: 22px;margin-bottom: 0"><strong>{{passenger.FirstName}}
                                                        {{passenger.LastName}}</strong></p>
                                                </div>
                                                <div class="col-12" style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #324567;
        box-shadow: none;
        padding: 0.5rem 1rem;color: white">
                                                    <p style="font-size: 18px;margin-bottom: 0">Biletinizi başarılı bir
                                                        şekilde satın aldınız. </p>
                                                    <p style="font-size: 18px;margin-bottom: 0">Uçuş detaylarınız ve
                                                        elektronik biletiniz aşağıdadır </p>
                                                </div>
                                            </div>
                                            <div class="row" style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #324567;
        box-shadow: none;
        padding: 0.5rem 1rem;color: white">
                                                <div class="col-6" style="padding: 15px;">
                                                    <p style="font-size: 16px;margin-bottom: 0">Rezervasyon No:</p>
                                                    <p style="font-size: 22px;margin-bottom: 0">
                                                        <strong>
                                                            {{Array.isArray(reservationAll.AirBookings.T_AirBooking)?reservationAll.AirBookings.T_AirBooking[0].BookingCode:reservationAll.AirBookings.T_AirBooking.BookingCode}}</strong>
                                                    </p>
                                                </div>
                                                <div class="col-6" style="padding: 15px;">
                                                    <p style="font-size: 16px;margin-bottom: 0">Bilet No:</p>
                                                    <p style="font-size: 22px;margin-bottom: 0">
                                                        <strong v-if="Array.isArray(reservationAll.AirBookings.T_AirBooking)">
                                                            <div v-for="AirBooking in reservationAll.AirBookings.T_AirBooking">
                                                                {{Array.isArray(AirBooking.BookingItems.T_AirBookingItem) ? AirBooking.BookingItems.T_AirBookingItem[index].TicketNumber : AirBooking.BookingItems.T_AirBookingItem.TicketNumber}}
                                                            </div>
                                                        </strong>
                                                        <strong v-else>
                                                        {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem) ? reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].TicketNumber : reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.TicketNumber }}
                                                        </strong>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col"></div>
                                    </div>
                                    <div class="row" style="margin-top: 7px">
                                        <div class="col"></div>
                                        <div class="col-10 p-0" style="">
                                            <table class="table w-100" style="border-radius: 12px;
                                                    background-color: #0a9fda;
                                                    box-shadow: none;
                                                    padding: 0.5rem 1rem;color:black">
                                                <th>GİDİŞ UÇUŞU</th>
                                                <th>KALKIŞ</th>
                                                <th>VARIŞ</th>
                                                <th>SÜRE</th>
                                                <th>BAGAJ</th>
                                                <tr v-for="segment in reservationAll.Segments"
                                                    v-if="segment.od_destination_code == reservationAll.Segments[0].od_destination_code">
                                                    <td>
                                                        <p><b>{{segment.marketing_airline_name}}</b></p>
                                                        <p>Class</p>
                                                        <p><b>{{segment.flight_number}}</b></p>
                                                    </td>
                                                    <td>
                                                        <p><b>{{segment.departure_time}}</b></p>
                                                        <p>{{segment.departure_day | moment("Do MMMM YYYY, dddd ")}}</p>
                                                        <p><b>{{segment.origin_name}} ({{segment.origin_code}})</b></p>
                                                    </td>
                                                    <td>
                                                        <p><b>{{segment.arrival_time}}</b></p>
                                                        <p>{{segment.arrival_day | moment("Do MMMM YYYY, dddd ")}}</p>
                                                        <p><b>{{segment.destination_name}}
                                                            ({{segment.destination_code}})</b></p>
                                                    </td>
                                                    <td>
                                                        <p>{{segment.duration}}</p>
                                                    </td>
                                                    <td>
                                                        <p v-if="Array.isArray(reservationAll.AirBookings.T_AirBooking)">
                                                            <span v-for="airbla in reservationAll.AirBookings.T_AirBooking">
                                                                {{Array.isArray(airbla.BookingItems.T_AirBookingItem)?airbla.BookingItems.T_AirBookingItem[index].Baggage:airbla.BookingItems.T_AirBookingItem.Baggage}}
                                                            </span>
                                                        </p>
                                                        <p v-else>
                                                            {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].Baggage:reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.Baggage}}
                                                        </p>
                                                    </td>

                                                    <!--td>
                                                        <p>{{segment.origin_name}} ({{segment.origin_code}})</p><p>{{segment.destination_name}} ({{segment.destination_code}})</p>
                                                    </td>
                                                    <td><p>{{segment.flight_number}}</p></td>
                                                    <td><p>{{segment.departure_day}} {{segment.departure_time}}</p></td>
                                                    <td><p>{{segment.arrival_day}} {{segment.arrival_time}}</p></td>
                                                    <td><p>{{segment.duration}}</p></td>
                                                    <td><p>{{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].Baggage:reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.Baggage}}</p></td>
                                                    <td><p>{{segment.booking_class}}</p></td>
                                                    <td><p>{{reservationAll.AirBookings.T_AirBooking.Status}}</p></td-->
                                                </tr>
                                            </table>
                                            <table class="table w-100" style="border-radius: 12px;
                                                        background-color: #0a9fda;
                                                        box-shadow: none;
                                                        padding: 0.5rem 1rem;color:black"
                                                   v-if="reservationAll.Segments.length > 1 && reservationAll.Segments[0].od_destination_code !== reservationAll.Segments[reservationAll.Segments.length-1].od_destination_code">
                                                <th>DÖNÜŞ UÇUŞU</th>
                                                <th>KALKIŞ</th>
                                                <th>VARIŞ</th>
                                                <th>SÜRE</th>
                                                <th>BAGAJ</th>
                                                <tr v-for="segment in reservationAll.Segments"
                                                    v-if="segment.od_destination_code == reservationAll.Segments[reservationAll.Segments.length-1].od_destination_code">
                                                    <td>
                                                        <p><b>{{segment.marketing_airline_name}}</b></p>
                                                        <p>Class</p>
                                                        <p><b>{{segment.flight_number}}</b></p>
                                                    </td>
                                                    <td>
                                                        <p><b>{{segment.departure_time}}</b></p>
                                                        <p>{{segment.departure_day | moment("Do MMMM YYYY, dddd ")}}</p>
                                                        <p><b>{{segment.origin_name}} ({{segment.origin_code}})</b></p>
                                                    </td>
                                                    <td>
                                                        <p><b>{{segment.arrival_time}}</b></p>
                                                        <p>{{segment.arrival_day | moment("Do MMMM YYYY, dddd ")}}</p>
                                                        <p><b>{{segment.destination_name}}
                                                            ({{segment.destination_code}})</b></p>
                                                    </td>
                                                    <td>
                                                        <p>{{segment.duration}}</p>
                                                    </td>
                                                    <td>
                                                        <p v-if="Array.isArray(reservationAll.AirBookings.T_AirBooking)">
                                                            <span v-for="airbla in reservationAll.AirBookings.T_AirBooking">
                                                                {{Array.isArray(airbla.BookingItems.T_AirBookingItem)?airbla.BookingItems.T_AirBookingItem[index].Baggage:airbla.BookingItems.T_AirBookingItem.Baggage}}
                                                            </span>
                                                        </p>
                                                        <p v-else>
                                                            {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].Baggage:reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.Baggage}}
                                                        </p>

                                                    </td>
                                                </tr>
                                            </table>

                                            <div class="col-12">
                                                <div class="row" style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #ebeef1;
        box-shadow: none;
        padding: 0.5rem 1rem;">
                                                    <div class="col-12"><p style=" margin-bottom: 0">TOPLAM TUTAR</p>
                                                    </div>
                                                    <div class="col-4">
                                                        <p style="margin-bottom: 0;font-size: 16px">Esas Ücret</p>
                                                        <p style="margin-bottom: 0;font-size: 28px;color:red">
                                                            <strong v-if="Array.isArray(reservationAll.AirBookings.T_AirBooking)">
                                                                {{topla(reservationAll.AirBookings.T_AirBooking,index,"BaseFare")}}
                                                            <!--span v-for="airbla2 in reservationAll.AirBookings.T_AirBooking">
                                                                {{Array.isArray(airbla2.BookingItems.T_AirBookingItem)? airbla2.BookingItems.T_AirBookingItem[index].BaseFare.slice(0,
                                                            -2):  airbla2.BookingItems.T_AirBookingItem.BaseFare.slice(0,
                                                            -2)}}
                                                            </span-->
                                                            </strong>
                                                            <strong v-else>
                                                                {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].BaseFare.slice(0,
                                                                -2):reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.BaseFare.slice(0,
                                                                -2)}}
                                                            </strong>
                                                        </p>
                                                    </div>
                                                    <div class="col-4">
                                                        <p style="margin-bottom: 0;font-size: 16px">Vergi</p>
                                                        <p style="margin-bottom: 0;font-size: 28px;color:red">
                                                            <strong v-if="Array.isArray(reservationAll.AirBookings.T_AirBooking)">
                                                                {{topla(reservationAll.AirBookings.T_AirBooking,index,"Taxes")}}
                                                            </strong>
                                                            <strong v-else>
                                                                {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].Taxes.slice(0,
                                                                -2):reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.Taxes.slice(0,
                                                                -2)}}
                                                            </strong>
                                                            </p>
                                                    </div>
                                                    <div class="col-4">
                                                        <p style="margin-bottom: 0;font-size: 16px">Toplam Fiyat</p>
                                                        <p style="margin-bottom: 0;font-size: 28px;color:red">
                                                            <strong v-if="Array.isArray(reservationAll.AirBookings.T_AirBooking)">
                                                                {{topla(reservationAll.AirBookings.T_AirBooking,index,"NetFare")}}

                                                            </strong>
                                                            <strong v-else>
                                                                {{Array.isArray(reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem)?reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem[index].NetFare.slice(0,
                                                                -2):reservationAll.AirBookings.T_AirBooking.BookingItems.T_AirBookingItem.NetFare.slice(0,
                                                                -2)}}
                                                            </strong>
                                                            </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="margin-top: 15px">
                                                <div style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #324567;
        box-shadow: none;
        padding: 0.5rem 1rem;color: white">Genel Kurallar
                                                </div>
                                                <div style="border-radius: 12px;
        border: 1px solid #bbb;
        background-color: #ebeef1;
        box-shadow: none;
        padding: 0.5rem 1rem;">
                                                    <p>&nbsp;</p>
                                                    <p>* YOLCULARIMIZIN HAVALİMANINA İÇ HAT UÇUŞLARINDA EN GEÇ 3 SAAT,
                                                        DIŞ HAT
                                                        UÇUŞLARINDA EN GEÇ 4 SAAT ÖNCE GELMELERİ GEREKMEKTEDİR.</p>

                                                    <p>* KALKIŞ VE VARIŞ SAATLERİ YEREL SAATE GÖRE BELİRTİLMİŞTİR.</p>

                                                    <p>* YOLCUNUN GİDECEGİ ÜLKE&#39;YE AİT GEÇERLİ BİR VİZESİ, AKTARMALI
                                                        UÇUŞLARDA TRANSİT VİZESİ
                                                        OLMAMASI SEBEBİYLE SEYAHATİN GERCEKLEŞMEMESİ HALİNDE ‘BİLETBUL
                                                        TURİZM’ SORUMLU
                                                        DEĞİLDİR.</p>

                                                    <p>* COVID 19 ÖNLEMLERİ KAPSAMINDA ÜLKELERE GİRİŞ VE ÇIKIŞLARDA
                                                        FARKLI KURALLAR
                                                        UYGULANMAKTADIR VE DEĞİŞKENLİK GÖSTERMEKTEDİR, GİDİLECEK OLAN
                                                        ÜLKENİN KURALLARINI
                                                        KONSOLOSLUKTAN TEYİT ETMEK YOLCUNUN SORUMLULUĞUNDADIR.</p>

                                                    <p>* COVID 19 ÖNLEMLERİ ÇERÇEVESİNDE MİSAFİRLERİN GÜVENLİĞİ İÇİN
                                                        UÇAK İÇERİSİNE KABİN BAGAJI
                                                        ALINMAYACAKTIR.UÇAK İÇERİSİNE SADECE 1 ADET KADIN EL ÇANTASI,
                                                        LAPTOP, EVRAK ÇANTASI VEYA
                                                        BEBEK MALZEME ÇANTASI ALINABİLECEKTİR.</p>

                                                    <p>* İÇ HAT UÇUŞLARINDA TÜRKİYE CUMHURİYETİ VATANDAŞLARI VE TÜRKİYE
                                                        CUMHURİYETİ YABANCI
                                                        KİMLİĞİNE SAHİP YOLCULARIMIZIN HES KODUNA SAHİP OLMALARI
                                                        ZORUNLUDUR.</p>

                                                    <p>* HAVAYOLLARININ KURALLARINA GÖRE ÖZELLİKLE UZUN MENZİLLİ
                                                        UÇUSLARDA CHECKIN
                                                        İŞLEMLERİ ERKEN BİTEBİLMEKTE OLUP, PARÇA BAGAJ HAKLARI
                                                        HAVAYOLUNA GÖRE
                                                        DEGİŞİKLİK ARZ EDEBİLMEKTEDİR.</p>
                                                    <br/><br/><br/>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="col"></div>
                                    </div>
                                    <hr>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </section>
    </div>
</template>

<script>
    import {mdbModal, mdbModalBody, mdbBtn, mdbIcon} from 'mdbvue';
    import findFlight from '@/components/findFlight';
    import axios from "axios";

    export default {
        components: {
            mdbModal,
            mdbModalBody,
            mdbBtn,
            mdbIcon,
            'bb-findflight': findFlight,

        },
        data() {
            return {
                modal: false,
                toggle: false,
                reservationAllCharter: [],
                reservationAll: [],
                booking_code: "",
                surname: "",
                passengersAll: [],
            };
        },
        methods: {
            params: function () {
                this.booking_code = this.$route.query.booking_code;
                this.surname = this.$route.query.surname;
                this.reservationCall();
            },
            topla(ar,index,name){

                let toplam = 0
                ar.filter(function (a) {
                   toplam += parseFloat(a.BookingItems.T_AirBookingItem[name])
                })

                return toplam.toFixed(2)
            },
            async reservationCall() {
                var self = this;
                await axios.post("https://www.biletbul.com/backend/public/api/v1/reservation", {
                    booking_code: self.booking_code,
                    surname: self.surname
                })
                    .then(function (response) {
                        if (response.data.status == true) {
                            console.log(response.data.data.departure_charter);
                            if (response.data.data.departure_charter) {
                                self.reservationAllCharter = response.data.data;
                            } else {
                                self.reservationAll = response.data.data.FinalizeShoppingResult.ShoppingFile;
                                if (Array.isArray(self.reservationAll.Passengers.T_Passenger)) {
                                    self.passengersAll = self.reservationAll.Passengers.T_Passenger;
                                } else {
                                    self.passengersAll.push(self.reservationAll.Passengers.T_Passenger);
                                }
                            }
                        }
                        /*response => this.sessionAll = [response.data.data]*/
                    });
                /*this.params();*/
            }
        },
        mounted() {
            this.params();

        }
    };
</script>

<style scoped>

    th {
        background-color: #0a9fda;
        font-size: 19px;
    }

    tr p {
        margin-bottom: 0;
        font-size: 15px;
    }

    tr b {
        font-size: 18px;
    }

    table.table th {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }

    table.table td {
        padding-top: 0.1rem;
        padding-bottom: 0.9rem;
    }

    .jumbotron {
        border-radius: 6px;
        border: 1px solid #bbb;
        background-color: #324567;
        box-shadow: none;
        padding: 0.5rem 1rem;
    }

    p {
        margin-bottom: 0;
    }
</style>
